import { motion } from "framer-motion";
import { PACKS } from "../../data/packs";
import { PackRow } from "./PackRow";
import { useLang } from "../../lib/i18n";

export const OrderSection = () => {
  const { t } = useLang();
  return (
    <section id="order-pack" data-testid="order-pack-section" className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9 }} className="mb-20 flex flex-col justify-between gap-8 md:flex-row md:items-end">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E6D9BC]">{t.orderEyebrow}</p>
          <h2 className="mt-6 max-w-3xl font-display text-5xl leading-[1] text-[#F4EFE6] md:text-7xl">
            {t.orderTitle[0]}<em className="text-[#E6D9BC]">{t.orderTitle[1]}</em>{t.orderTitle[2]}
          </h2>
        </div>
        <p className="max-w-sm text-base leading-relaxed text-[#BAC6CE]">
          {t.orderBody}
        </p>
      </motion.div>
      <div className="space-y-28 md:space-y-40">
        {PACKS.map((p, i) => (
          <PackRow key={p.id} pack={p} index={i} />
        ))}
      </div>
    </section>
  );
};
